<template>
  <div class="center">
    <div v-if="show == 'loading'" class="loading">
      <LoadingSpinner />
    </div>
    <div v-if="show == 'redirectionFailed'" class="redirect">
      <h2>Die Automatische Weiterleitung hat nicht funktionert.</h2>
      <br />
      <p>Um weitergeleitet zu werden, klicken Sie bitte</p>
      <a :href="redirectURL">hier.</a>
    </div>
    <ProcessRunner
      class="process-runner"
      v-if="show == 'processRunner'"
      :params="processParams"
      :id="processID"
    />
    <div class="error-message">
      <div v-if="show == 'notFound'" class="not-found">
        <h2>Oops.. wir konnten deine URL nicht finden !</h2>
        <img width="450px" src="../assets/img/nodata.svg" />
      </div>
      <div v-if="show == 'expired'" class="expired">
        <h2>Oops.. deine URL ist abgelaufen !</h2>
        <img width="450px" src="../assets/img/expired.svg" />
      </div>
      <div v-if="show == 'customExpired'" v-html="customExpiredMessage"></div>
    </div>
  </div>
</template>

<script>
import ProcessRunner from './ProcessRunner.vue';
import LoadingSpinner from '../components/widgets/LoadingSpinner.vue';

export default {
  name: 'redirect',
  data() {
    return {
      show: 'loading',
      processParams: null,
      processID: null,
      redirectURL: null,
      customExpiredMessage: null,
      countdown: 4,
      countdownIntrvl: null,
    };
  },
  methods: {
    getRedirection() {
      var url = process.env.VUE_APP_DATA_API;

      url += '/redirection/' + this.urlID;

      fetch(url, {
        method: 'GET',
      })
        .then((response) => {
          if (response.status == 400) {
            this.show = 'notFound';
          } else return response.json();
        })
        .then((jsn) => {
          // Handle expired
          if (jsn.status == 'expired') {
            let m = jsn.expirationMessage;
            if (m != '' && m != null) {
              this.customExpiredMessage = m;
              this.show = 'customExpired';
            } else this.show = 'expired';
          } else if (jsn.url.includes('process-runner')) {
            // Handle Flows
            let urlParams = jsn.url.split('process-runner/')[1];
            this.processID = urlParams.split('?')[0];
            let processParams = urlParams.split('?')[1];
            if (processParams) {
              this.processParams = this.transformURLtoObject(processParams);
            }
            this.show = 'processRunner';
          } else {
            // Handle redirect
            this.pushToPath(jsn.url);
          }
        });
    },
    transformURLtoObject(u) {
      return JSON.parse(
        '{"' + u.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function (key, value) {
          return key === '' ? value : decodeURIComponent(value);
        }
      );
    },
    pushToPath(p) {
      window.location.replace(p);
      //clearInterval(this.countdownIntrvl);
    },
  },
  mounted() {
    this.getRedirection();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    urlID() {
      return this.$route.params.id;
    },
  },
  components: {
    ProcessRunner,
    LoadingSpinner,
  },
};
</script>

<style scoped>
body {
  line-height: 8px;
}
.center {
  width: 100%;
  height: 100%;
}

.center h2 {
  margin-bottom: 25px;
}

.process-runner {
  height: 100%;
  width: 100%;
}

.error-message {
  text-align: center;
}
</style>
